import { CustomSVGProps, SVG } from './svg';
import { env } from 'config/env';

const coins = {
  voceopina: (props: CustomSVGProps) => (
    <SVG viewBox="0 0 47 47" fill="none" {...props}>
      <circle cx="23.8799" cy="23.9548" r="23" fill="url(#paint0_linear_8057_2297)" />
      <circle
        cx="23.8805"
        cy="23.9534"
        r="18.0073"
        fill="url(#paint1_linear_8057_2297)"
        stroke="#FFE34A"
        strokeWidth="0.785473"
      />
      <path
        d="M18.4417 17.61H11.1904L24.1391 36.6445L36.5697 17.61H29.8365L24.1391 25.8859L18.4417 17.61Z"
        fill="#E5AF22"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8057_2297"
          x1="33.0799"
          y1="72.2548"
          x2="23.8799"
          y2="10.1548"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.382255" stopColor="#94731C" />
          <stop offset="0.606028" stopColor="#FFC223" />
          <stop offset="1" stopColor="#FDE148" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8057_2297"
          x1="31.2405"
          y1="62.5934"
          x2="23.8805"
          y2="-1.80658"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.490907" stopColor="#FDE148" />
          <stop offset="0.828581" stopColor="#FFC223" />
          <stop offset="1" stopColor="#94731C" />
        </linearGradient>
      </defs>
    </SVG>
  ),

  queopinas: (props: CustomSVGProps) => (
    <SVG viewBox="0 0 42 43" fill="none" {...props}>
      <circle cx="21" cy="21.1997" r="21" fill="url(#paint0_linear_9970_14807)" />
      <circle
        cx="21.0012"
        cy="21.2003"
        r="16.0175"
        fill="url(#paint1_linear_9970_14807)"
        stroke="#FFE34A"
        strokeWidth="1.56497"
      />
      <path
        d="M21.1029 11.1241C15.7447 11.1241 11.4199 15.1774 11.4199 20.231C11.4199 24.6175 14.7127 28.2886 19.0872 29.1465V31.4826H23.265V29.099C27.5905 28.1454 30.7853 24.5218 30.7853 20.231C30.7853 15.2249 26.4605 11.1241 21.1029 11.1241ZM23.265 26.9061V25.4279H19.0872V26.9536C17.4653 25.8568 16.8264 23.2825 16.8264 20.326C16.8264 16.321 18.4483 13.0795 21.2009 13.0795C23.9535 13.0795 25.5264 16.321 25.5264 20.326C25.5264 23.2343 24.7889 25.7136 23.265 26.9061Z"
        fill="#E5AF22"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9970_14807"
          x1="29.4"
          y1="65.2997"
          x2="21"
          y2="8.59971"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.382255" stopColor="#94731C" />
          <stop offset="0.606028" stopColor="#FFC223" />
          <stop offset="1" stopColor="#FDE148" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9970_14807"
          x1="27.7212"
          y1="56.4803"
          x2="21.0012"
          y2="-2.31973"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.490907" stopColor="#FDE148" />
          <stop offset="0.828581" stopColor="#FFC223" />
          <stop offset="1" stopColor="#94731C" />
        </linearGradient>
      </defs>
    </SVG>
  ),

  quedices: (props: CustomSVGProps) => (
    <SVG viewBox="0 0 127 127" fill="none" {...props}>
      <g filter="url(#filter0_d_9970_14390)">
        <path
          d="M63.3739 114.181C94.0365 114.181 118.893 89.3238 118.893 58.6613C118.893 27.9987 94.0365 3.14185 63.3739 3.14185C32.7114 3.14185 7.85449 27.9987 7.85449 58.6613C7.85449 89.3238 32.7114 114.181 63.3739 114.181Z"
          fill="url(#paint0_linear_9970_14390)"
        />
        <path
          d="M63.377 100.802C86.6517 100.802 105.52 81.9345 105.52 58.6598C105.52 35.3851 86.6517 16.5172 63.377 16.5172C40.1023 16.5172 21.2344 35.3851 21.2344 58.6598C21.2344 81.9345 40.1023 100.802 63.377 100.802Z"
          fill="url(#paint1_linear_9970_14390)"
          stroke="#FFE34A"
          strokeWidth="1.99254"
        />
        <path
          d="M75.6632 77.9473C83.5921 77.9473 90.355 73.179 93.1187 66.4732C93.1757 66.3219 93.2353 66.1805 93.2923 66.0291C93.3047 65.9944 93.3171 65.9721 93.3271 65.9473C94.1309 63.9303 94.5625 61.7372 94.5625 59.4648C94.5625 49.4594 86.1648 41.2502 75.7749 41.2502C75.5417 41.2502 63.6136 41.2502 63.3804 41.2626V44.3041C67.975 47.8493 70.9124 53.3296 70.9124 59.4623C70.9124 65.595 68.0221 71.0504 63.3457 74.6328L63.3804 77.9224C63.6136 77.9348 75.4251 77.9473 75.6583 77.9473H75.6632ZM71.4433 45.1675C73.9142 45.1675 75.8617 45.1551 75.9783 45.1551C79.4069 45.1551 81.9349 47.9411 83.2894 52.1164C83.3341 52.2454 83.3837 52.3967 83.4184 52.5357C83.9791 54.6097 84.2471 56.9888 84.2471 59.5417C84.2471 67.5524 81.0988 74.0349 75.8642 74.0349C75.76 74.0349 73.8596 74.0349 71.4458 74.0225V45.165L71.4433 45.1675Z"
          fill="#E5AF22"
        />
        <path
          d="M69.7495 59.4648C69.7495 54.0441 67.2885 49.1567 63.3836 45.81C60.0716 42.9769 55.7351 41.2502 50.9668 41.2502C40.5769 41.2502 32.1816 49.3527 32.1816 59.4623C32.1816 68.2297 38.5724 75.5755 47.0595 77.2923V81.9687H55.162V77.2005C58.2631 76.4885 61.0739 75.0545 63.3836 73.0971C67.291 69.7504 69.7495 64.8755 69.7495 59.4672V59.4648ZM55.1644 72.8143V69.8522H47.0595V72.9061C43.9112 70.7155 42.6757 65.5603 42.6757 59.6483C42.6757 51.6376 45.8116 45.1551 51.1529 45.1551C56.4942 45.1551 59.5482 51.6376 59.5482 59.6483C59.5482 65.466 58.1142 70.4228 55.1644 72.8143Z"
          fill="#E5AF22"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9970_14390"
          x="-0.000238895"
          y="-4.673e-05"
          width="126.749"
          height="126.748"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.71284" />
          <feGaussianBlur stdDeviation="3.92737" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3 0 0 0 0 0.217511 0 0 0 0 0.0025 0 0 0 0.29 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9970_14390" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9970_14390"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_9970_14390"
          x1="80.7549"
          y1="175.967"
          x2="58.5462"
          y2="26.0651"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.38" stopColor="#94731C" />
          <stop offset="0.61" stopColor="#FFC223" />
          <stop offset="1" stopColor="#FDE148" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9970_14390"
          x1="74.1291"
          y1="152.732"
          x2="56.3635"
          y2="-2.72195"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#FDE148" />
          <stop offset="0.83" stopColor="#FFC223" />
          <stop offset="1" stopColor="#94731C" />
        </linearGradient>
      </defs>
    </SVG>
  ),
};

export function Coin({ size = 46, ...props }: CustomSVGProps) {
  const Icon = coins[env.appId] ?? coins.voceopina;

  return <Icon size={size} {...props} />;
}
